<template>
    <v-container align-center justify-center style ="min-height: 600px; padding-top: 68px">
        
        <v-row>
            <v-col cols="12" sm="10" offset-sm="1" md="4" offset-md="4" style="padding: 12px 0;">
                <v-card>
                    <v-card-text class="pt-4">
                        <img src = 'img/logo-wedrive.svg' width="300" style="display: block; margin: 15px auto;"/>
                        <div>
                            <v-form v-model="valid" ref="form">
																<v-row class="m-0 p-0 font-weight-bold">
																	<v-col cols="4" style="position: relative; right: -20px; text-align: right; float: right;">
																		<span>{{ $t('login.as-username') }}</span>
																	</v-col>
																	<v-col cols="4" class="d-flex justify-center">
																		<v-switch inset 
																		color="primary" 
																		class="ma-0 pa-0 custom-off" 
																		style="position: relative; left: 8px;"
																		v-model="isLicensePlate"/>
																	</v-col>
																	<v-col cols="4" style="position: relative; left: -20px; float: left;">
																		<span>{{ $t('login.as-license-plate') }}</span>
																	</v-col>
																</v-row>
                                <v-text-field ref="username"
                                :label="isLicensePlate ? $t('login.license-plate') : $t('login.username')"
                                v-model="username"/>
                                <v-text-field ref="password"
                                :label="$t('login.password')"
                                v-model="password"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPassword ? 'password' : 'text'"
                                @click:append="() => (showPassword = !showPassword)"
                                @keyup.enter="doSubmit()"/>
                                <v-layout justify-space-between>
                                    <v-btn class="wedrive-vbtn primary" @click="doSubmit()" 
                                        :class=" { 'darken-4 white--text' : valid, disabled: !valid }"
                                        :loading="isLoading"
                                        :disabled="isLoading">
                                        {{ $t('login.submit') }}
                                    </v-btn>
                                </v-layout>                             
                            </v-form>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="showSessionExpiredError" style="margin-top: 10px; margin-bottom: 0; padding: 0;">
            <v-col cols="12" style="padding: 0;">
                <v-alert type="error">
                {{ $t('app.session-expired') }}
                </v-alert>
            </v-col>
        </v-row>

        <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
            {{ alertText }}
            <v-btn text @click="showAlert=false">
							{{ $t('app.buttons.close') }}
            </v-btn>
        </v-snackbar>
        <!-- FIN BLOQUE ESTADO PETICIONES -->

        <v-row v-if="$store.state.wedrive.initApp" style="position: fixed; bottom: 0px; left: 0px; z-index: 0;">
            <iframe ref="iframe" id="map0" src="maps.html" style="border: 0; width: 1px; height: 1px;"></iframe>
        </v-row>

        <v-row style="position: fixed; bottom: 0; right: 60px">
            <span class="caption grey--text lighten-5 show-version">{{version}}</span>
        </v-row>

    </v-container>
</template>

<script>
import BaseModule from '../../common/BaseModule'
import api from "../../../api/wedrive"; 
import cordova from "../../../api/cordova"; 
import discovery from "../../../discovery"

export default {
    name: "LoginMain", 
    mixins: [ BaseModule ],
    components: {},
    data() {
        return {
            valid: false,
            isLoading: false,
            showPassword: true,
            username: '',
            password: '',
						isLicensePlate: false,
            showAlert: false,
            alertColor: 'error',
            alertText: '',
            alertTimeout: 3000,
            showSessionExpiredError: false,
            version: 'x.x.x',
        }
    },
    mounted() {
        if (this.$store.state.wedrive.initApp) {
            var timerId = setTimeout(() => {
                this.$refs.iframe.contentWindow.centerMap(0.0, 0.0);
                this.$store.commit('wedrive/setInitApp', false);
                clearTimeout(timerId);
            }, 400);
        }
                    
        this.$refs.username.rules.push(this.validationRules.required);
        this.$refs.password.rules.push(this.validationRules.required);
    },
    methods: {
        doShowAlert: function(payload) {
            this.alertText = payload.text;
            this.alertColor = payload.color;
            this.alertTimeout = payload.timeout;
            this.showAlert = true;
        },
        doSubmit: function() {
            if (!this.$refs.form.validate()) {
                return;
            }

            if (this.isLicensePlate) {
                this.$store.commit('wedrive/setIsManager', false);
            } else {
                this.$store.commit('wedrive/setIsManager', true);
            }

            this.isLoading = true;

            api.login(this.username, this.password,
            (data) => {
                this.isLoading = false;
                this.showSessionExpiredError = false;
                this.$store.commit('wedrive/setToken', data);
                window.localStorage.setItem("vue-token", data);
                this.getUserInfo();
            },
            (error) => {
                this.isLoading = false;
                this.$log.error(error);
                this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
            });
        },
        getUserInfo() {
            this.isLoading = true;

            api.userInfo(
            (data) => {
                this.isLoading = false;
                this.$store.commit('wedrive/setUser', data);
                this.$store.commit('wedrive/setNumAttempts', 0);
                this.$store.commit('wedrive/setMobileData', null);
                this.$store.commit('wedrive/setMobileIndex', -1);
                this.$router.push({ name: 'home' });
            },
            (error) => {
                this.isLoading = false;
                this.$log.error(error);
                this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
            });
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('wedrive/setToken', null);
            vm.$store.commit('wedrive/setIsManager', false);
            vm.$store.commit('wedrive/setShowLastUpdate', false);

            vm.showSessionExpiredError = vm.$route.query.sessionExpired;
            vm.version = discovery.version;
            
            cordova.initCompleted();
        });
    }
}
</script>

<style>
.custom-off .v-input--selection-controls__input div {
  color: #A41735 !important;
}

@media screen and ( max-height: 520px )
{
   .show-version{
        display: none;
    }
}

@media screen and ( min-height: 521px )
{
   .show-version{
        display: block;  
    }
}

</style>